import React from 'react'
import clsx from 'clsx'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { nl2br } from 'utils/text'

interface ViewMetaProps {
  description: string
  reflection: string
}

const ViewMeta = ({ description, reflection }: ViewMetaProps) => {
  const descRef = React.useRef<HTMLDivElement>(null)
  const reflectionRef = React.useRef<HTMLDivElement>(null)
  const [showMore, setShowMore] = React.useState({
    desc: false,
    refleksi: false,
  })
  const [isExpanded, setExpanded] = React.useState({
    desc: false,
    refleksi: false,
  })

  const toggleExpanded = (newValue) => {
    setExpanded((old) => ({ ...old, ...newValue }))
  }

  React.useLayoutEffect(() => {
    if (descRef.current?.clientHeight < descRef.current?.scrollHeight) {
      setShowMore((old) => ({ ...old, desc: true }))
    }
    if (
      reflectionRef.current?.clientHeight < reflectionRef.current?.scrollHeight
    ) {
      setShowMore((old) => ({ ...old, refleksi: true }))
    }
  }, [])
  return (
    <div className="p-4">
      <div className="mb-6">
        <Text className="mb-2" variant="heading-sm">
          Deskripsi
        </Text>
        <Text
          as="div"
          ref={descRef}
          className={clsx('break-words', !isExpanded.desc && 'line-clamp-3')}
          dangerouslySetInnerHTML={{
            __html: nl2br(description),
          }}
        />
        {showMore.desc && (
          <button
            className="flex items-center"
            onClick={() => toggleExpanded({ desc: !isExpanded.desc })}
          >
            <Text variant="body-sm" className="underline">
              <strong>{isExpanded.desc ? 'Ringkas' : 'Selengkapnya'}</strong>
            </Text>
            <Icon
              as="i"
              color="default"
              fontSize="default"
              className={clsx(
                isExpanded.desc ? 'transform rotate-180 origin-center' : ''
              )}
            >
              keyboard_arrow_down_icon
            </Icon>
          </button>
        )}
      </div>
      <div>
        <Text className="mb-2" variant="heading-sm">
          Refleksi
        </Text>
        <Text
          as="div"
          ref={reflectionRef}
          className={clsx(
            'break-words',
            !isExpanded.refleksi && 'line-clamp-3'
          )}
          dangerouslySetInnerHTML={{
            __html: nl2br(reflection),
          }}
        />
        {showMore.refleksi && (
          <button
            className="flex items-center"
            onClick={() => toggleExpanded({ refleksi: !isExpanded.refleksi })}
          >
            <Text variant="body-sm" className="underline">
              <strong>
                {isExpanded.refleksi ? 'Ringkas' : 'Selengkapnya'}
              </strong>
            </Text>
            <Icon
              className={clsx(
                isExpanded.refleksi ? 'transform rotate-180 origin-center' : ''
              )}
              as="i"
              color="default"
              fontSize="default"
            >
              keyboard_arrow_down_icon
            </Icon>
          </button>
        )}
      </div>
    </div>
  )
}

export default ViewMeta
